import { PreloadErrorDeps } from './preloadError.types';

export const PRELOAD_RELOAD_AT_KEY = 'vite-preload-reloaded-at';
export const PRELOAD_RELOAD_COOLDOWN_MS = 60_000;

const DEFAULT_DEPS: PreloadErrorDeps = {
  now: () => Date.now(),
  reload: () => window.location.reload(),
  get storage() {
    return window.sessionStorage;
  },
};

const canReload = (deps: PreloadErrorDeps, now: number) => {
  try {
    const lastReloadAt = parseInt(deps.storage.getItem(PRELOAD_RELOAD_AT_KEY) ?? '', 10);
    const hasReloadedRecently =
      !Number.isNaN(lastReloadAt) && lastReloadAt <= now && now - lastReloadAt < PRELOAD_RELOAD_COOLDOWN_MS;
    return !hasReloadedRecently;
  } catch {
    return false;
  }
};

const markReload = (deps: PreloadErrorDeps, now: number) => {
  try {
    deps.storage.setItem(PRELOAD_RELOAD_AT_KEY, String(now));
    return true;
  } catch {
    return false;
  }
};

export const handlePreloadError = (event: Event, deps: PreloadErrorDeps = DEFAULT_DEPS): void => {
  const now = deps.now();
  if (!canReload(deps, now) || !markReload(deps, now)) return;
  event.preventDefault();
  deps.reload();
};
